import { IGeoData } from '@app/models/Shop';

export const placeGeoData = (geoData: IGeoData) => {
  const parts = [];

  if (geoData?.district) {
    parts.push(<span key="district">{geoData.district}</span>);
  }

  if (geoData?.area) {
    parts.push(<span key="area">р-н {geoData.area}</span>);
  }

  if (geoData?.metroName) {
    parts.push(<span key="metro">метро {geoData.metroName}</span>);
  }

  return parts.map((part, index) => (
    <span key={index}>
      {part}
      {index < parts.length - 1 && ', '}
    </span>
  ));
};
